var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarlogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2500 2500",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2434.7,986.8l-703.3,0.1c-17.9,0-29.6-5.3-29.6-30l0-104.4c0-30.1-16.2-46-45.6-46H851c-30.1,0-45.6,17-45.6,45.7l0,104.4 c0,22-10.4,30-29.7,30l-460.9,0.1c-35.3,0-55.9,16.8-66.5,38.9L23.8,1464.2c-2.9,5.6-4.6,12.1-4.6,18.7c0,17.3,11.3,39.8,42.8,39.8 l713.6-0.1c22,0,29.7,10,29.7,30l0,104.3c0,31.5,18.2,45.7,45.7,45.7h805.1c27.4,0,45.7-13.3,45.7-45.4l-0.1-104.3 c0-21.3,9-30,29.6-30l447.6-0.1c30.8,0,53-8.1,68.5-36.8l221.9-433.5c4.9-9.4,8.1-14.7,8.1-25.8 C2477.4,997.1,2452,986.8,2434.7,986.8z M2257.4,1161.5l-107,209.3c-6.7,12.2-18.6,12.6-27,12.6h-530.8c-22,0-30,9.9-30,29.9 l0,120.4c0,19.9-8.8,29.6-30.2,29.6H974.7c-18.7,0-30.1-6.6-30.1-29.9l0-120.3c0-22-10.1-29.8-30.1-29.8H263.6c-16,0-27-10-27-24 c0-4.1,1-7.8,2.8-11.3l107-209.2c4.1-7.3,10.8-12.6,26.9-12.6l541.2,0.1c18.7,0,30.3-7.5,30.3-30.2V975.7c0-21.3,9.3-29.8,29.9-29.8 l557.6-0.1h0c20,0,30,8.9,30,30.2v120.3c0,20.7,9.6,29.8,30.3,29.8h640.5c20.4,0,27.1,13.4,27.1,24.1 C2260.2,1154.1,2259.2,1158,2257.4,1161.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarlogo1);
export default __webpack_public_path__ + "static/media/carlogo (1).2e85085f631a93d9fb790864b11c877b.svg";
export { ForwardRef as ReactComponent };